import { createAction } from 'redux-actions';
import { normalize } from 'normalizr';
import { push } from '@lagunovsky/redux-react-router';
import { pick } from 'ramda';

import { db } from '../firebase';
import secondHandBoardgameSchema,
  { secondHandBoardgames as secondHandBoardgamesSchema } from '../schema/secondHandBoardgame';
import { collection, query, where, orderBy as ob, getDocs, updateDoc, doc, getDoc, addDoc } from 'firebase/firestore';

const FETCH_SECOND_HAND_BOARDGAMES_REQUEST = 'FETCH_SECOND_HAND_BOARDGAMES_REQUEST';
const FETCH_SECOND_HAND_BOARDGAMES_SUCCESS = 'FETCH_SECOND_HAND_BOARDGAMES_SUCCESS';
const FETCH_SECOND_HAND_BOARDGAMES_FAILED = 'FETCH_SECOND_HAND_BOARDGAMES_FAILED';

const fetchSecondHandBoardgamesRequest = createAction(FETCH_SECOND_HAND_BOARDGAMES_REQUEST);
const fetchSecondHandBoardgamesSuccess = createAction(FETCH_SECOND_HAND_BOARDGAMES_SUCCESS);
const fetchSecondHandBoardgamesFailed = createAction(FETCH_SECOND_HAND_BOARDGAMES_FAILED);

const GET_SECOND_HAND_BOARDGAME_REQUEST = 'GET_SECOND_HAND_BOARDGAME_REQUEST';
const GET_SECOND_HAND_BOARDGAME_SUCCESS = 'GET_SECOND_HAND_BOARDGAME_SUCCESS';
const GET_SECOND_HAND_BOARDGAME_FAILED = 'GET_SECOND_HAND_BOARDGAME_FAILED';

const getSecondHandBoardgameRequest = createAction(GET_SECOND_HAND_BOARDGAME_REQUEST);
const getSecondHandBoardgameSuccess = createAction(GET_SECOND_HAND_BOARDGAME_SUCCESS);
const getSecondHandBoardgameFailed = createAction(GET_SECOND_HAND_BOARDGAME_FAILED);

const FETCH_ALL_SECOND_HAND_BOARDGAMES_REQUEST = 'FETCH_ALL_SECOND_HAND_BOARDGAMES_REQUEST';
const FETCH_ALL_SECOND_HAND_BOARDGAMES_SUCCESS = 'FETCH_ALL_SECOND_HAND_BOARDGAMES_SUCCESS';
const FETCH_ALL_SECOND_HAND_BOARDGAMES_FAILED = 'FETCH_ALL_SECOND_HAND_BOARDGAMES_FAILED';

const fetchAllSecondHandBoardgamesRequest = createAction(FETCH_ALL_SECOND_HAND_BOARDGAMES_REQUEST);
const fetchAllSecondHandBoardgamesSuccess = createAction(FETCH_ALL_SECOND_HAND_BOARDGAMES_SUCCESS);
const fetchAllSecondHandBoardgamesFailed = createAction(FETCH_ALL_SECOND_HAND_BOARDGAMES_FAILED);

const MARK_BOARDGAME_AS_SOLD_REQUEST = 'MARK_BOARDGAME_AS_SOLD_REQUEST';
const MARK_BOARDGAME_AS_SOLD_SUCCESS = 'MARK_BOARDGAME_AS_SOLD_SUCCESS';
const MARK_BOARDGAME_AS_SOLD_FAILED = 'MARK_BOARDGAME_AS_SOLD_FAILED';

const markBoardgameAsSoldRequest = createAction(MARK_BOARDGAME_AS_SOLD_REQUEST);
const markBoardgameAsSoldSuccess = createAction(MARK_BOARDGAME_AS_SOLD_SUCCESS);
const markBoardgameAsSoldFailed = createAction(MARK_BOARDGAME_AS_SOLD_FAILED);

const CREATE_SECOND_HAND_BOARDGAME_REQUEST = 'CREATE_SECOND_HAND_BOARDGAME_REQUEST';
const CREATE_SECOND_HAND_BOARDGAME_SUCCESS = 'CREATE_SECOND_HAND_BOARDGAME_SUCCESS';
const CREATE_SECOND_HAND_BOARDGAME_FAILED = 'CREATE_SECOND_HAND_BOARDGAME_FAILED';

const createSecondHandBoardgameRequest = createAction(CREATE_SECOND_HAND_BOARDGAME_REQUEST);
const createSecondHandBoardgameSuccess = createAction(CREATE_SECOND_HAND_BOARDGAME_SUCCESS);
const createSecondHandBoardgameFailed = createAction(CREATE_SECOND_HAND_BOARDGAME_FAILED);

const UPDATE_SECOND_HAND_BOARDGAME_REQUEST = 'UPDATE_SECOND_HAND_BOARDGAME_REQUEST';
const UPDATE_SECOND_HAND_BOARDGAME_SUCCESS = 'UPDATE_SECOND_HAND_BOARDGAME_SUCCESS';
const UPDATE_SECOND_HAND_BOARDGAME_FAILED = 'UPDATE_SECOND_HAND_BOARDGAME_FAILED';

const updateSecondHandBoardgameRequest = createAction(UPDATE_SECOND_HAND_BOARDGAME_REQUEST);
const updateSecondHandBoardgameSuccess = createAction(UPDATE_SECOND_HAND_BOARDGAME_SUCCESS);
const updateSecondHandBoardgameFailed = createAction(UPDATE_SECOND_HAND_BOARDGAME_FAILED);

export const getSecondHandBoardgames = (orderBy = 'title') => {
  return dispatch => {
  
    dispatch(fetchSecondHandBoardgamesRequest());
    
    const q = query(
      collection(db, 'secondHandBoardgames'),
      where('sold', '==', false),
      ob(orderBy)
    )

    getDocs(q)
      .then(snapshot => {
        const boardgames = snapshot.docs
          .map(doc => Object.assign({}, { id: doc.id }, doc.data()));
        
          dispatch(fetchSecondHandBoardgamesSuccess({ ...normalize(boardgames, secondHandBoardgamesSchema) }));
      })
      .catch(error => {
        dispatch(fetchSecondHandBoardgamesFailed({
          notie: { type: 'error', message: error },
        }));
      });
  };
};

export const getAllSecondHandBoardgames = (orderBy = 'title') => {
  return dispatch => {
  
    dispatch(fetchAllSecondHandBoardgamesRequest());
    
    const q = query(
      collection(db, 'secondHandBoardgames'),
      ob(orderBy)
    )

    getDocs(q)
      .then(snapshot => {
        const boardgames = snapshot.docs
          .map(doc => Object.assign({}, { id: doc.id }, doc.data()));
        
          dispatch(fetchAllSecondHandBoardgamesSuccess({ ...normalize(boardgames, secondHandBoardgamesSchema) }));
      })
      .catch(error => {
        dispatch(fetchAllSecondHandBoardgamesFailed({
          notie: { type: 'error', message: error },
        }));
      });
  };
};

export const markBoardgameAsSold = (bg, sold = true) => {
  return dispatch => {
    dispatch(markBoardgameAsSoldRequest());

    const update = {
      sold,
      soldAt: sold ? new Date() : null,
    };

    updateDoc(
        doc(db, 'secondHandBoardgames', bg.id),
        update
      )
      .then(() => {
        const boardgame = Object.assign({}, bg, update);
        dispatch(markBoardgameAsSoldSuccess({
          ...normalize(boardgame, secondHandBoardgameSchema)
        }));
      })
      .catch(error => dispatch(markBoardgameAsSoldFailed({
        notie: { type: 'error', message: error },
      })));
  };
};

export const getSecondHandBoardgame = (id, onlyUnsold = true) => {
  return dispatch => {
    dispatch(getSecondHandBoardgameRequest());

    getDoc(
        doc(db, 'secondHandBoardgames', id)
      )
      .then(doc => {
        const boardgame = doc.exists()
          ? Object.assign({}, { id: doc.id }, doc.data())
          : {};

        dispatch(getSecondHandBoardgameSuccess({
          ...normalize(boardgame, secondHandBoardgameSchema)
        }));
      })
      .catch(error => {
        dispatch(getSecondHandBoardgameFailed({
          notie: { type: 'error', message: error },
        }));
      });
  };
};

export const createBoardgame = (bg) => {
  return dispatch => {
    dispatch(createSecondHandBoardgameRequest());

    addDoc(
        collection(db, 'secondHandBoardgames'),
        bg
      )
      .then(ref => Object.assign({}, { id: ref.id }, bg))
      .then(boardgame => {
        dispatch(createSecondHandBoardgameSuccess( { ...normalize(boardgame, secondHandBoardgameSchema) }))
        dispatch(push('/admin/replay'));
      })
      .catch(error => dispatch(createSecondHandBoardgameFailed({
        notie: { type: 'error', message: error },
      })));
  };
};

export const updateBoardgame = (id, bg) => {
  return dispatch => {
    dispatch(updateSecondHandBoardgameRequest());

    const data = pick([
      'title', 'description', 'price',
      'edition', 'image', 'language',
      'languageDependant', 'updatedAt'
    ], bg);

    updateDoc(
        doc(db, 'secondHandBoardgames', id),
        data
      )
      .then(() => {
        dispatch(updateSecondHandBoardgameSuccess( { ...normalize(bg, secondHandBoardgameSchema) }))
        dispatch(push('/admin/replay'));
      })
      .catch(error => dispatch(updateSecondHandBoardgameFailed({
        notie: { type: 'error', message: error },
      })));
  };
};

export const actions = {
  FETCH_SECOND_HAND_BOARDGAMES_REQUEST,
  FETCH_SECOND_HAND_BOARDGAMES_SUCCESS,
  FETCH_SECOND_HAND_BOARDGAMES_FAILED,
  GET_SECOND_HAND_BOARDGAME_REQUEST,
  GET_SECOND_HAND_BOARDGAME_SUCCESS,
  GET_SECOND_HAND_BOARDGAME_FAILED,
  FETCH_ALL_SECOND_HAND_BOARDGAMES_REQUEST,
  FETCH_ALL_SECOND_HAND_BOARDGAMES_SUCCESS,
  FETCH_ALL_SECOND_HAND_BOARDGAMES_FAILED,
  MARK_BOARDGAME_AS_SOLD_REQUEST,
  MARK_BOARDGAME_AS_SOLD_SUCCESS,
  MARK_BOARDGAME_AS_SOLD_FAILED,
  CREATE_SECOND_HAND_BOARDGAME_REQUEST,
  CREATE_SECOND_HAND_BOARDGAME_SUCCESS,
  CREATE_SECOND_HAND_BOARDGAME_FAILED,
  UPDATE_SECOND_HAND_BOARDGAME_REQUEST,
  UPDATE_SECOND_HAND_BOARDGAME_SUCCESS,
  UPDATE_SECOND_HAND_BOARDGAME_FAILED,
};